import Axios from "axios";
import { getImpersonationFromStorage } from "../contexts/ImpersonationContext";

const httpClient = Axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

httpClient.interceptors.request.use((config) => {
  const session = getImpersonationFromStorage();
  if (session && !window.location.pathname.startsWith("/platform")) {
    config.headers = config.headers ?? {};
    config.headers["x-impersonate-user-id"] = session.target.id;
    config.headers["x-impersonate-session-id"] = session.sessionId;
  }
  return config;
});

export default httpClient;
